const autoplayVideos = ['clubmedcancun']

export const videoIsAutoplay = (appId) => autoplayVideos.indexOf(appId) >= 0



// WEBPACK FOOTER //
// ./src/constants/video-parameters.js